import * as React from 'react';
import './App.css';
import { persistor } from 'src/store';
import { PersistGate } from 'redux-persist/integration/react';
import HeaderContainer from 'src/modules/commons/header/Header.container';
import 'react-bootstrap';
import FooterComponent from 'src/modules/commons/footer/Footer.component';
import ModalHandler from 'src/modules/commons/modal-handler/ModalHandler.container';
import UserbackComponent from './modules/commons/userback/Userback.component';

class App extends React.Component {

  public render(): React.ReactNode {
    return (
      <div className="app">
        <PersistGate persistor={persistor}>
          <HeaderContainer/>
          <div className="gap-20" />
          <div className="Content">
            {this.props.children}
          </div>
          <FooterComponent/>
          <ModalHandler/>
          <UserbackComponent/>
        </PersistGate>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx